export const getGmtOffset = (rawDate) => {
  const gmt = (new Date(rawDate)?.getTimezoneOffset() * -1) / 60;
  const gmtSinged = gmt > 0 ? `+${gmt}` : gmt;
  return ` (GMT${gmtSinged})`;
};
